import { AppThunk } from '../../../store/rootReducer';
import { annotationSelector } from '../selectors/annotation-task.selectors';
import * as annotationClient from '../clients/annotation.client';
import { ecgIdSelector } from '../selectors/ecg.selectors';

export const cleanUp = (): AppThunk => async (dispatch, getState) => {
  const annotation = annotationSelector(getState());
  const currentEcgId = ecgIdSelector(getState());
  if (currentEcgId == null) {
    return;
  }

  if (annotation?.id != null && annotation?.ecgId === currentEcgId) {
    await annotationClient.markAsFinished(annotation.id);
  }
};
